import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const filesList: ThemeUICSSObject = {
  listStyle: 'none',
  m: spacing(0),
  p: spacing(0),

  '.filesList__file': {
    display: 'flex',
    alignItems: 'center',

    '.filesList__file__delete': {
      m: spacing(0),
      minWidth: '24px',
      mr: spacing(4),
    },

    '.filesList__file__name': {
      pl: '7px',
      pt: '7px',
    },

    '.filesList__file__icon': {
      minWidth: '24px',
    },

    mb: spacing(2),
  },
  /* PREPEND HERE */
};

export default filesList;
